exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n.loading {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 100px;\n}\n.loading .progressMessage {\n  position: absolute !important;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.loading .progressMessage .message {\n  color: #ffffff;\n  font-size: 20px !important;\n  text-align: center;\n  width: 250px;\n  position: absolute;\n  top: 100%;\n  left: calc(50%-250px);\n  font-size: 14px;\n  margin-top: 8px;\n}\ndiv#root > .loading {\n  position: absolute;\n}\n", ""]);

// exports
